<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item :to="{ path: '/admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item><a href="/admin">我的购物车</a></el-breadcrumb-item>
    </el-breadcrumb>

    <el-row style="background-color: #fff; padding: 10px">
      <el-col>
        <el-button style="float: right; padding: 3px 0" type="text" @click="edit('del')"
          >删除</el-button
        >
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="edit('edit')"
          v-if="editflag == false"
          >编辑</el-button
        >
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="edit('cancel')"
          v-else
          >取消</el-button
        >
        <el-button style="float: right; padding: 3px 0" type="text" @click="goods_add"
          >确认采购</el-button
        >
      </el-col>
    </el-row>
    <el-card class="box-card" v-for="(item, index) in result.data" :key="index">
      <div slot="header" class="clearfix">
        <span>{{ item.title }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="del_cart_id(item.id)"
          >删除</el-button
        >
      </div>

      <div v-for="(attr, i) in item.attr" :key="i" class="text item">
        <div v-for="(goods, j) in attr" :key="j">
          <el-row style="padding: 10px">
            <el-col :span="5">颜色：{{ j }}</el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="3"> <span>数量：</span> </el-col
                ><el-col :span="5">
                  <span
                    v-if="editflag == false"
                    style="display: block; padding-top: 5px"
                    >{{ goods }}</span
                  >

                  <span v-if="editflag == true">
                    <el-input
                      v-model="qty[index + '_' + i + '_' + j]"
                      placeholder="请输入内容"
                      @input="setNum(index + '_' + i + '_' + j, item.id)"
                      @blur="editflag = false"
                    ></el-input>
                  </span>
                  <span v-else>
                    {{ setQty(index + "_" + i + "_" + j, goods) }}
                  </span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="5">
              <span>
                <el-button
                  type="text"
                  @click="del_cart(item.id, j)"
                  style="float: right; margin-top: 0px; padding-top: 3px"
                  >删除</el-button
                ></span
              ><span>价格:{{ item.stock_price[i][j] }} 元</span></el-col
            >
          </el-row>
        </div>
      </div>
    </el-card>

    <el-dialog :visible.sync="dialogStoreVisible">
      <div slot="title">我的采购单</div>
      <el-form label-width="100px">
        <el-row>
          <el-col
            ><p>用户搜索</p>

            <el-autocomplete
              v-model="state_user"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              @select="handleSelect"
            ></el-autocomplete>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <p>采购用户</p>
            {{ this.current_user }}
          </el-col>
        </el-row>

        <div v-if="show != false">
          <el-row>
            <el-col><p>收货地址:</p> </el-col>
          </el-row>
          <el-row v-for="(item, index) in address_user.data" :key="index">
            <el-col>
              <el-radio v-model="address_id" :label="item.id">{{ "" }}</el-radio
              >{{ item.province }}{{ item.city }}{{ item.county }} {{ item.detail }}
              {{ item.name }} {{ item.phone }}
            </el-col>
          </el-row>
        </div>
        <div v-if="show != false">
          <el-card>
            <el-row>
              <el-col>
                <div>余额:{{ money }}元</div>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </el-form>
      <el-row>
        <el-col>
          <el-card
            class="box-card"
            v-for="(item, index) in result.data"
            :key="index"
            style="margin-bottom: 10px"
          >
            <div slot="header" class="clearfix">
              <span>{{ item.title }}</span>
            </div>
            <div v-for="(attr, i) in item.attr" :key="i" class="text item">
              <div v-for="(goods, j) in attr" :key="j">
                <el-row style="padding: 10px">
                  <el-col :span="5">颜色：{{ j }}</el-col>
                  <el-col :span="12">
                    <el-row>
                      <el-col :span="6"> <span>数量：</span> </el-col
                      ><el-col :span="5">
                        <span style="display: block; padding-top: 5px">{{ goods }}</span>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5">
                    <div v-if="item.purchase_price.length > 0">
                      采购价: {{ item.purchase_price[i][j] }}
                    </div>

                    价格:{{ item.stock_price[i][j] }}
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-card class="box-card" style="margin-bottom: 10px">
        <el-row>
          <el-col> 总价：{{ this.result.totalprice }} {{ result.data }}</el-col></el-row
        >
      </el-card>
      <el-row>
        <el-col>
          <div>
            <el-button @click="dialogStoreVisible = false">取 消</el-button>
            <el-button type="primary" @click="addOrder">确 定</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      address_id: 0,
      show: false,
      dialogStoreVisible: false,
      multipleSelection: [],
      shop_cart: {},
      qty: {},
      editflag: false,
      restaurants: [],
      state_user: "",
      level: "",
      current_user: "",
      money: 0,
      user_id: 0,
    };
  },
  methods: {
    ...mapActions({
      getShopCartDataAction: "getShopCartDataAction",
      getAgentUserAction: "getAgentUserAction",
      getUserAddressAction: "getUserAddressAction",
      getWalletDataAction: "getWalletDataAction",
      addShopCartOrderAction: "addShopCartOrderAction",
    }),

    setQty(k, v) {
      this.qty[k] = v;
    },
    addOrder() {
      if (this.current_user == "") {
        this.$message({
          message: "请选择采购用户",
          type: "warning",
        });

        return;
      }
      if (this.address_id == "0") {
        this.$message({
          message: "请采购用户配送地址",
          type: "warning",
        });

        return;
      }

      if (this.wallet.data.money < this.result.totalprice) {
        this.$message({
          message: "余额不足,请选择充值",
          type: "warning",
        });

        return;
      }
      let order = {
        orders: JSON.stringify(this.result),
        totalprice: this.result.totalprice,
        address_id: this.address_id,
        user_id: this.user_id,
      };
      // this.addShopCartOrderAction(order);
      // this.dialogStoreVisible = false;
      this.addShopCartOrderAction(order);
    },
    querySearchAsync(queryString, cb) {
      this.getAgentUserAction({ username: queryString, type: "post" });

      // this.restaurants = this.agent_user.options;

      var results = queryString
        ? this.restaurants.filter(this.createStateFilter(queryString))
        : this.restaurants;
      this.show = false;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 200 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },

    handleSelect(item) {
      this.level = item.level;
      this.current_user = item.value;

      this.getUserAddressAction({ id: item.id });
      this.shop_cart = sessionStorage.getItem("goods_cart");
      this.getShopCartDataAction({ value: this.shop_cart, id: item.id });
      this.user_id = item.id;
      this.getWalletDataAction({ id: item.id });
    },
    //删除指定商品
    del_cart_id(id) {
      //查找存在的商品
      let goods_cart = JSON.parse(sessionStorage.getItem("goods_cart"));

      let goods_key = "goods_" + id;

      if (goods_cart != null) {
        delete goods_cart[goods_key];
      }

      if (JSON.stringify(goods_cart) == "{}") {
        this.$message({
          message: "购物车清空成功",
          type: "warning",
        });
        setTimeout(() => {
          this.clearCart();
        }, 600 * Math.random());
      } else {
        sessionStorage.setItem("goods_cart", JSON.stringify(goods_cart));

        this.shop_cart = sessionStorage.getItem("goods_cart");
        if (this.user_id > 0) {
          this.getShopCartDataAction({ value: this.shop_cart, id: this.user_id });
        } else {
          this.getShopCartDataAction({ value: this.shop_cart, id: 0 });
        }
      }
    },
    del_cart(id, sku) {
      //查找存在的商品
      let goods_cart = JSON.parse(sessionStorage.getItem("goods_cart"));
      let goods_key = "goods_" + id;
      for (let k in goods_cart[goods_key]) {
        for (let kk in goods_cart[goods_key][k]) {
          if (sku == kk) {
            goods_cart[goods_key].splice(k, 1);
            if (goods_cart[goods_key].length == 0) {
              delete goods_cart[goods_key];
            }
            break;
          }
        }
      }
      //更新购物车
      //

      if (JSON.stringify(goods_cart) == "{}") {
        this.$message({
          message: "购物车清空成功",
          type: "warning",
        });
        setTimeout(() => {
          this.clearCart();
        }, 600 * Math.random());
      } else {
        sessionStorage.setItem("goods_cart", JSON.stringify(goods_cart));
        this.shop_cart = sessionStorage.getItem("goods_cart");
        if (this.user_id > 0) {
          this.getShopCartDataAction({ value: this.shop_cart, id: this.user_id });
        } else {
          this.getShopCartDataAction({ value: this.shop_cart, id: 0 });
        }
      }

      // this.getShopCartDataAction({ value: this.shop_cart, id: 0 });
      console.log("tag", id, sku);
    },
    setNum(e, id) {
      // alert(JSON.stringify(e));
      let goods = e.split("_");
      // alert(goods[2]);
      // alert(JSON.stringify(this.result.data[goods[0]]["attr"][goods[1]][goods[2]]));
      // alert(id);
      // alert(this.qty[e]);
      // alert(goods[2]);
      this.$set(this.result.data[goods[0]]["attr"][goods[1]], [goods[2]], this.qty[e]);

      //查找存在的商品
      let goods_cart = JSON.parse(sessionStorage.getItem("goods_cart"));
      let goods_key = "goods_" + id;
      for (let k in goods_cart[goods_key]) {
        for (let kk in goods_cart[goods_key][k]) {
          if (goods[2] == kk) {
            goods_cart[goods_key][k][kk] = this.qty[e];
            break;
          }
        }
      }
      //更新购物车
      sessionStorage.setItem("goods_cart", JSON.stringify(goods_cart));

      this.shop_cart = sessionStorage.getItem("goods_cart");
      if (this.user_id > 0) {
        this.getShopCartDataAction({ value: this.shop_cart, id: this.user_id });
      } else {
        this.getShopCartDataAction({ value: this.shop_cart, id: 0 });
      }

      // this.result[goods[0]]["attr"][goods[1]][goods[2]]
    },
    clearCart() {
      sessionStorage.removeItem("goods_cart");
      this.$router.push({ name: "admin" });
    },
    goods_add() {
      this.dialogStoreVisible = true;
    },

    edit(type) {
      if (type == "edit") {
        this.editflag = true;
      }

      if (type == "cancel") {
        this.editflag = false;
      }
      if (type == "del") {
        this.$message({
          message: "购物车清空成功",
          type: "warning",
        });
        // setTimeout(() => {
        //   this.clearCart();
        // }, 600 * Math.random());
      }
    },
  },

  mounted() {
    this.shop_cart = sessionStorage.getItem("goods_cart");

    if (this.shop_cart == null) {
      this.$message({
        message: "请选择下单哦",
        type: "warning",
      });
      setTimeout(() => {
        this.clearCart();
      }, 600 * Math.random());
    } else {
      this.getShopCartDataAction({ value: this.shop_cart, id: 0 });
    }

    // this.restaurants = this.loadAll();
  },
  computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      result: (state) => state.shop_cart.result,

      agent_user: (state) => state.agentuser.result,
      address_user: (state) => state.address.result,
      wallet: (state) => state.wallet.result,
      shop_cart_data: (state) => state.shop_cart.result,
    }),
  },
  watch: {
    wallet(newdata, olddata) {
      if ("data" in newdata) {
        this.money = newdata.data.money;
      }
      console.log(newdata, olddata);
    },
    address_user(newdata, olddata) {
      console.log(newdata, olddata);
      if (newdata.data.length > 0) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    state_user(newdata, olddata) {
      if (newdata == "") {
        this.getShopCartDataAction({ value: this.shop_cart, id: 0 });
        this.current_user = "";
        this.address_id = 0;
      }
      console.log("tag", newdata, olddata);
    },
    agent_user(newdata, olddata) {
      if (newdata.options.length == 0) {
        this.current_user = "";
      } else {
        this.restaurants = newdata.options;
      }
      console.log("tag", newdata, olddata);
    },
    shop_cart_data(newdata, olddata) {
      if (newdata.code == "301") {
        this.$message({
          message: "恭喜你，下单成功",
          type: "success",
        });

        setTimeout(() => {
          this.clearCart();
        }, 500 * Math.random());
      }
      console.log("tag", newdata, olddata);
    },
    result(newdata, olddata) {
      if (JSON.stringify(newdata) === "{}") {
        this.$message({
          message: "请先下单",
          type: "warning",
        });
      }
      console.log("tag", olddata);
    },

    // result(newdata, olddata) {
    //   if (newdata.length > 0) {
    //     for (let i = 0; i < newdata.length; i++) {
    //       //单品折扣
    //       if (newdata[i].discount.length > 0) {
    //         // alert(newdata[i].stock_price.length);

    //         for (let k in newdata[i].stock_price) {
    //           for (let kk in newdata[i].stock_price[k]) {
    //             if (this.level == "省代") {
    //               this.setPurchasePrice(i, kk, newdata[i].stock_price[k][kk] * newdata[i].discount[0]["discount1"]);
    //             }
    //           }
    //         }
    //         // if (this.level == "省代") {
    //         // }
    //         // if (this.level == "市代") {
    //         // }
    //         // if (this.level == "区代") {
    //         // }
    //         // } else {
    //       }
    //     }
    //   }

    //   console.log("tag", olddata);
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page_box_num {
  background-color: #fff;
  padding: 8px;
}
</style>
